
// eslint-disable-next-line import/prefer-default-export
export const thirtyMinutes = 1000 * 60 * 30